<script>
	// From Lucide
	import { Users } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Users class={iconClass} />
